export const data: any = {
  NEXT_PUBLIC_DEPLOYMENT_ENV: "development",
  NEXT_PUBLIC_BASE_URL: "https://dev.trimble.com",
  NEXT_PUBLIC_SITEMAP_BASE_URL: "https://dev.trimble.com",
  NEXT_PUBLIC_SITE_MACHINE_NAME: "development",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "citn2sn5tdjr",
  NEXT_PUBLIC_ONETRUST_ID: "8b739b3a-1d4a-4e73-a407-d3ba92a4f3c2",
  NEXT_PUBLIC_ALGOLIA_SITE_INDEX: "global-production",
}
